// Lyrics and audio rights helpers. Availability decisions come from the programme API.

// Kept for compatibility with existing consumers. The browser no longer
// infers or overrides the viewer's country.
export function getViewerCountry() {
  return 'unknown';
}

// Region lookup is intentionally disabled: country and region decisions are
// returned by the programme API.
export function regionOf() {
  return null;
}

// Interpret only the lyrics decision returned by the programme API.
export function lyricsDecision(lyrics) {
  if (lyrics?.status === 'ok') {
    return { allowed: true, reason: '', note: lyrics.note || '' };
  }
  if (lyrics?.status === 'denied') {
    return { allowed: false, reason: lyrics.reason || '', note: lyrics.note || '' };
  }
  return { allowed: false, reason: '', note: '' };
}

const REASON_MESSAGES = {
  not_reviewed: 'Rights review is pending.',
  rights_hold: 'Rights are on hold.',
  region: 'Not available in this region.',
  no_text: 'No lyrics are available.',
  audio_off: 'Audio is turned off.',
  not_available: 'Audio is not available.',
  forbidden: 'Audio access is not permitted.',
  no_file: 'No audio file is available.',
};

export function lyricsMessage(response) {
  return REASON_MESSAGES[response?.reason] || '';
}

// Lyrics are usable when the API marks them available and returns verses.
export function usableLyrics(lyrics) {
  if (lyrics?.status !== 'ok') return null;
  if (!lyrics.verses?.length) return null;
  return lyrics;
}

// Audio availability is determined by the API response, not browser rules.
export function audioAllowed(audioResponse) {
  return Boolean(audioResponse?.url);
}

// Preserve the preview helper shape while accepting the short-lived URL
// returned by the programme API. Do not persist this URL.
export function pieceFiles(previewResponse, instrument) {
  if (!previewResponse?.url) return null;
  return {
    instrument: previewResponse.instrument || instrument || '',
    audio: '',
    preview: previewResponse.url,
  };
}

export const audioBase = () => (import.meta.env?.VITE_AUDIO_BASE_URL || '').replace(/\/$/, '');